import { ListResult } from '@shared/api';
import { Api } from '../../Api';
import { IServiceTransfersDto } from './interfaces';
import { IServiceTransfersGetQuery } from './query';

export class Transfers {
    private static _basePath = '/transfers';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${Transfers._basePath}`;
        return {
            async getHistory(query: IServiceTransfersGetQuery) {
                const path = '/history';
                return await Api.get<ListResult<IServiceTransfersDto>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
        };
    }
}
